<template>
  <v-container class="grey lighten-5">
    <v-row>
      <v-col cols="12">
        <h4 style="text-decoration:underline" class="secondary-color">
          <span id="Attributes" class="theme-main-color-darker">
            Set Attributes and User Values
          </span>
        </h4>
        <p class="caption">
          Add new attributes as <span class="bold-text primary--text text--darken-2">someAttribute=someValue</span>
          <br>
          Separate attributes with new line.
        </p>
      </v-col>
      <v-col cols="6">
        <v-textarea
          label="Add attributes"
          filled
          v-model="setGetAttributes"
        ></v-textarea>
      </v-col>
      <v-col cols="6">
        <v-textarea
          label="User attributes"
          filled
          v-model="setGetUserAttributes"
        ></v-textarea>
      </v-col>
      <v-col cols="12">
        <v-btn
          rounded
          depressed
          class="theme-main-color white--text"
          :disabled="lookForChanges"
          @click="updateAttributes"
        >
          Update attributes
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { getAttributesAsObject } from '@/utils/helpers'

export default {
  name: 'attributes-section',
  computed: {
    ...mapState({
      attributes: ({ context }) => context.attributes,
      userAttributes: ({ context }) => context.userAttributes
    }),
    lookForChanges () {
      return this.attributes === '' && this.userAttributes === ''
    },
    setGetAttributes: {
      get: function () {
        return this.attributes
      },
      set: function (val) {
        this.setAttributes(val)
      }
    },
    setGetUserAttributes: {
      get: function () {
        return this.userAttributes
      },
      set: function (val) {
        this.setUserAttributes(val)
      }
    }
  },
  methods: {
    ...mapMutations([
      'setAttributes',
      'setUserAttributes',
      'reloadCashierMutation'
    ]),
    updateAttributes () {
      const getObj = getAttributesAsObject(this.attributes, this.userAttributes)
      window.CashierInstance.set({
        ...getObj
      })
      this.reloadCashierMutation()
    }
  }
}
</script>
